import React from "react";
import { useTranslation } from "next-i18next";
import {
	Section,
	Container,
	HighlightBar,
	Title,
	Text,
	TextSecondary,
	WhatsAppButton,
	BannerImgWrapper,
	BannerImg,
	LocationsWrapper,
	LocationsText,
	LocationsGrid,
	Location,
	Flag,
	LocationTitle,
	LocationPhone,
} from "./styles";
import { phoneNumbers, whatsappNumber } from "../../data/contact-info";
import WhatsappStartChatButton from "../WhatsappStartChatButton";

export const locations = [
	{
		location: "São Paulo e Rio de Janeiro, BR",
		phone: `${phoneNumbers["rj-sp"]} (nacional)`,
		flag: "/landings/assets/icons/flag-brazil.svg",
		contacts: {
			phoneNumber: phoneNumbers["rj-sp"].replace(/\s/g, ''), // 08005580066
			whatsappNumber, // Brasil e Portugal usam este número
			email: "faleconosco@verzel.com.br"
		}
	},
	// {
	// 	location: ", BR",
	// 	phone: phoneNumbers["rj-sp"],
	// 	flag: "/landings/assets/icons/flag-brazil.svg",
	// },
	{
		location: "Lisboa, PT",
		phone: phoneNumbers["pt-lisboa"],
		flag: "/landings/assets/icons/flag-portugal.svg",
		contacts: {
			phoneNumber: phoneNumbers["de-berlim"].replace(/\s/g, ''), // +4915128787315
			whatsappNumber, // Brasil e Portugal usam este número
			email: "contactus.pt@verzel.com.br"
		}
	},
	{
		location: "Berlim, DE",
		phone: phoneNumbers["de-berlim"],
		flag: "/landings/assets/icons/flag-germany.svg",
		contacts: {
			phoneNumber: phoneNumbers["de-berlim"].replace(/\s/g, ''), // +4915128787315
			whatsappNumber: phoneNumbers["de-berlim"].replace(/\s/g, '').replace('+', ''), // 4915128787315
			email: "contactus.de@verzel.com.br"
		}
	},
];

export default function ContactSection({ title, description, isMobile }) {
	const { t } = useTranslation();
	
	return (
		<Section id="contact-us">
			<div className="relative container-blog">
				<Container>
					<HighlightBar />
					<Title dangerouslySetInnerHTML={{ __html: title }} />
					<Text dangerouslySetInnerHTML={{ __html: description }} />

					<div className="start-chat-wrapper">
						<WhatsappStartChatButton />
					</div>
				</Container>

				<BannerImgWrapper>
					<BannerImg
						src={
							!isMobile
								? "/landings/assets/images/products/laptop.png"
								: "/landings/assets/images/products/laptop-mobile.png"
						}
						alt="Notebook"
					/>
				</BannerImgWrapper>

				<LocationsWrapper>
					<LocationsText
						dangerouslySetInnerHTML={{
							__html: !isMobile
								? t("contactUs.locations.description.desktop")
								: t("contactUs.locations.description.mobile"),
						}}
					/>
					<LocationsGrid>
						{locations.map((location) => (
							<Location key={location.location}>
								<Flag src={location.flag} alt={location.location} />
								<LocationTitle>{location.location}</LocationTitle>
								<LocationPhone href={`tel:${location.phone}`}>
									{location.phone}
								</LocationPhone>
							</Location>
						))}
					</LocationsGrid>
				</LocationsWrapper>
			</div>
		</Section>
	);
}
